import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { CustomizationService } from '../services/customization.service';
import { LoginGuard } from '../shared/guard/login.guard';
import { AuthGuard } from '../shared/guard/auth.guard';
import { NotFoundComponent } from '../shared/components/not-found/not-found.component';

const routes: Routes = [
  {
    path: '',
    resolve: {
      customization: CustomizationService,
    },
    children: [
      { path: '', redirectTo: '/login', pathMatch: 'full' },
      { path: 'login', component: LoginComponent },
      { path: 'dashboard', canActivate: [AuthGuard], loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule) },
      { path: 'card-generator', canActivate: [AuthGuard], loadChildren: () => import('./id-card-generator/id-card-generator.module').then(m => m.IdCardGeneratorModule) },
      { path: 'capture', canActivate: [AuthGuard], loadChildren: () => import('./capture/capture.module').then(m => m.CaptureModule) },
      { path: 'verifier', canActivate: [AuthGuard], loadChildren: () => import('./verifier/verifier.module').then(m => m.VerifierModule) },
      { path: 'payment', loadChildren: () => import('./payment/payment.module').then(m => m.PaymentModule) },
      { path: 'setup', canActivate: [AuthGuard], loadChildren: () => import('./setup/setup.module').then(m => m.SetupModule) },
      { path: 'email-templates', canActivate: [AuthGuard], loadChildren: () => import('./email-template/email.template.module').then(m => m.EmailTemplateModule) },
      {
        path: 'not-found',
        component: NotFoundComponent
      },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
